import { useState, useEffect } from 'react';
import { downloadData } from 'aws-amplify/storage';
import { sanitizeHtml } from '../../../utils/htmlSanitizer';
import { Message } from '../types';

export const useMessageContent = (record: Message) => {
    const [messageHtml, setMessageHtml] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const getMessagePath = (record: Message): string | null => {
        return record.htmlObjectKey || record.htmlPath || record.textAsHtmlPath || record.textObjectKey || record.textPath || null;
    };

    const loadMessageContent = async (path: string): Promise<string> => {
        const { body } = await downloadData({
            path: path as string,
            options: {}
        }).result;
        return await body.text();
    };

    useEffect(() => {
        const loadMessage = async () => {
            setLoading(true);
            setError(null);

            const path = getMessagePath(record);

            if (!path) {
                setMessageHtml('<p>No message content available. The backend sendEmail mutation is not storing message content in S3.</p>');
                setLoading(false);
                return;
            }

            try {
                const content = await loadMessageContent(path);
                setMessageHtml(sanitizeHtml(content));
            } catch (err) {
                console.error('Failed to load message:', err);
                setError('Failed to load message content');
                setMessageHtml('<p>Failed to load message content</p>');
            } finally {
                setLoading(false);
            }
        };

        loadMessage();
    }, [record.htmlPath, record.htmlObjectKey, record.textAsHtmlPath, record.textObjectKey, record.textPath]);

    return { messageHtml, loading, error };
};
